import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  needHelp: {
    id: 'K0UDmO',
    defaultMessage: 'Need help?',
    description: 'title for the help section',
  },
  helpCenter: {
    id: '5q7/zX',
    defaultMessage: 'Help Center',
    description: 'link to the help center',
  },
  vastKnowledge: {
    id: 'ZbRhUH',
    defaultMessage: 'Search our vast Knowledge Base',
    description: 'description of the help center',
  },
  shipstationUniversity: {
    id: 'WRNUoE',
    defaultMessage: 'ShipStation University',
    description: 'link to the shipstation university',
  },
  shipstationUniversityDescription: {
    id: 'LguzCV',
    defaultMessage: 'Self guided courses to get you started',
    description: 'description of the shipstation university',
  },
  community: {
    id: '081Yul',
    defaultMessage: 'Community',
    description: 'link to the community discussion board',
  },
  communityDescription: {
    id: 'Zo1cOm',
    defaultMessage: 'Connect & learn from other merchants',
    description: 'description of the community board',
  },
});
